interface TouchInfo {
  startX: number
  startY: number
  endX: number
  endY: number
}

type SwipeCallback = () => void

// Store handlers weakly to support proper cleanup
const handlerMap = new WeakMap<
  HTMLElement,
  { onTouchStart: (e: TouchEvent) => void; onTouchEnd: (e: TouchEvent) => void }
>()

export const installSwipe = (
  ref: HTMLElement,
  onSwipeLeft: SwipeCallback = () => {},
  onSwipeRight: SwipeCallback = () => {},
): void => {
  const touchInfo: TouchInfo = {
    startX: 0,
    startY: 0,
    endX: 0,
    endY: 0,
  }

  const checkDirection = (): void => {
    if (Math.abs(touchInfo.endX - touchInfo.startX) < 30) return
    if (Math.abs(touchInfo.endY - touchInfo.startY) > 30) return
    if (touchInfo.endX < touchInfo.startX) onSwipeLeft()
    if (touchInfo.endX > touchInfo.startX) onSwipeRight()
  }

  const onTouchStart = (e: TouchEvent): void => {
    const touch = e.changedTouches[0]
    touchInfo.startX = touch.screenX
    touchInfo.startY = touch.screenY
  }

  const onTouchEnd = (e: TouchEvent): void => {
    const touch = e.changedTouches[0]
    touchInfo.endX = touch.screenX
    touchInfo.endY = touch.screenY
    checkDirection()
  }

  // Store handlers for later removal
  handlerMap.set(ref, { onTouchStart, onTouchEnd })

  ref.addEventListener('touchstart', onTouchStart)
  ref.addEventListener('touchend', onTouchEnd)
}

export const uninstallSwipe = (ref: HTMLElement): void => {
  const handlers = handlerMap.get(ref)
  if (handlers) {
    ref.removeEventListener('touchstart', handlers.onTouchStart)
    ref.removeEventListener('touchend', handlers.onTouchEnd)
    handlerMap.delete(ref)
  }
}
